<template>
  <div class="exam">
    <test-result-table :results="results" :test="test"></test-result-table>

    <h2 class="h2">Übersicht aller Prüfungsfragen</h2>
    <accordion :items="items"></accordion>
  </div>

</template>

<script>
import TestResultTable from './TestResultTable'

export default {

  name: 'TestResult',

  components: {
    TestResultTable
  },

  props: {
    test: {
      type: Object,
      required: true,
    },

    exam: {
      type: Object,
      required: true,
    },

    results: {
      type: Array,
      required: true,
    },
  },

  computed: {
    items: function(){
      let items = []
      this.exam.questions.map( (question, index) => {
        //let shortQuestion = question.text.substring(0,50) + '...'
        items.push({
          header: `Frage #${index + 1}: ${question.text}`,
          content: this.getAccordionContent( question ),
          icon: this.isCorrectAnswer( question.id ) ? 'fa fa-check text-success-500' : 'fa fa-times text-red-500'
        })
      })
      return items
    },
  },

  methods: {
    isCorrectAnswer: function( questionId ) {
      let isCorrect = false
      this.results.answered_right.map( id => {
        if( id === questionId ) isCorrect = true
      })
      return isCorrect
    },

    getAccordionContent: function( question ) {
      let content = ''
      content += '<div>'

      question.choices.map( choice => {
        let userAnswer = this.checkUserAnswer(question, choice)

        let color = ( choice.is_correct ) ? 'text-success-500' : ''
        content += `<span class="${color}">${choice.text} ${userAnswer}<br></span>`

      })

      if( question.type === 3 ) {
        content += '<br>'
        content += '<strong>Deine Antwort:</strong>'
        content += this.getUserFreeAnswer( question )
      }
      content += '</div>'

      return content
    },

    checkUserAnswer: function(question, choice) {
      let isUserAnswer = ''
      this.test.answers.map( answer => {
        if( answer.question_id === question.id ) {
          answer.selections.map( selection => {
            if( selection.choice_id === choice.id ) isUserAnswer = '<strong>(Deine Antwort)</strong>'
          })
        }
      })
      return isUserAnswer
    },

    getUserFreeAnswer: function( question ) {
      let userAnswer = null
      this.test.answers.map( answer => {
        if( answer.question_id === question.id ) {
          userAnswer = answer.text
        }
      })
      return userAnswer
    },
  },

}
</script>

<style scoped>

</style>